<div qaiAccordionItem [expanded]="expanded()" #item="qaiAccordionItem" class="card">
  <div qaiAccordionHeader class="header">
    <span class="title">{{ title() }}</span>
    @if (subHeading()) {
      <span class="sub-heading">{{ subHeading() }}</span>
    }
    <span class="status">
      <ng-content select="[status]" />
    </span>
    <span class="controls">
      <ng-content select="[controls]" />
    </span>
    <button qaiAccordionToggle aria-label="Toggle" class="toggle">
      <qai-icon
        [kind]="item.expanded() ? 'chevron-up' : 'chevron-down'"
        [size]="icon()?.size ?? '20px'"
        [color]="icon()?.color"
      />
    </button>
  </div>
  <div qaiAccordionBody class="body">
    <ng-content />
  </div>
</div>
